// extracted by mini-css-extract-plugin
export default {"header":"header_header__z8ezc","lottiePlayer":"header_lottiePlayer__KDpDP"};